/*
 * Module responsible for the quick create assoc. content modal.  Allows an author
 * to create a new piece of content and apply it to a topic in one step.
 */

define([
  "marionette",
  "jquery",
  "messaging/messenger",
  "modules/quickCreate/quickContentModal/quickContentModalView",
  "modules/shared/contentMapping/contentMappingModule",
  "modules/quickCreate/quickContentModal/currentContent/currentContentModule",
], function (
  Marionette,
  $,
  Messenger,
  QuickContentModalView,
  ContentMappingModule,
  CurrentContentModule,
) {
  var QuickContentModalController = Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "quickContentModal";
      this.region = options.region;
      this.selectedContent = null;
      this._setUpVents();
    },
    show: function (conversationBundlePlusQuickCreate) {
      var quickCreate = conversationBundlePlusQuickCreate.quickCreate;
      var conversation = conversationBundlePlusQuickCreate.node;
      this.layout = new QuickContentModalView.quickContentModalLayout({ model: quickCreate });
      this.contentEditor = this.addSubModule(
        new ContentMappingModule({ region: this.layout.editor }),
      );
      this.currentContent = this.addSubModule(
        new CurrentContentModule({ region: this.layout.currentContent }),
      );

      this.layout.on(
        "done",
        function () {
          if (this.selectedContent !== null) {
            conversation.setAssociatedContent(this.selectedContent);
          } else {
            conversation.deleteAssociatedContent();
          }
          //update the quick create model based on the 'mark as complete' checkbox
          this._updateQuickCreate(quickCreate, conversation);
          Messenger.vent.trigger("close:modal");
        },
        this,
      );

      this.layout.on(
        "cancel",
        function () {
          Messenger.vent.trigger("close:modal");
        },
        this,
      );

      this.layout.on(
        "show",
        function () {
          this.contentEditor.show();
          conversationBundlePlusQuickCreate.node.onSynced(function () {
            this.selectedContent = conversation.getAssociatedContent();
            this.currentContent.show(this.selectedContent);
          }, this);
        },
        this,
      );

      this.showRegion(this.layout);
    },
    _setUpVents: function () {
      //handle when we select a piece of content
      Messenger.vent.on(
        "list:item:selected",
        function (model) {
          this.selectedContent = model;
          //update selected content
          this.currentContent.show(model);
        },
        this,
      );

      //User selected content via the typeahead search, so select the content
      Messenger.vent.on(
        "mapping:search:selected",
        function (model) {
          this.selectedContent = model;
          //update selected content
          this.currentContent.show(model);
        },
        this,
      );

      //User removed the current associated content
      Messenger.vent.on(
        "remove:selected:content",
        function () {
          this.selectedContent = null;
          this.currentContent.show(this.selectedContent);
        },
        this,
      );
    },
    _updateQuickCreate: function (quickCreate, node) {
      //if the completed checkbox is enabled, the set component as completed
      if (this.layout.getCompleteness()) {
        quickCreate.set("contentComponent", 2);
      } else if (quickCreate.get("contentComponent") === 2 || node.dirty) {
        //the checkbox is not checked.  If the component was completed or if the node is dirty, set the component as 'started'.
        quickCreate.set("contentComponent", 1);
      } //otherwise, leave it alone.
    },
  });

  return QuickContentModalController;
});
